import * as types from './types';
import { UserService } from '../../services/user.service';
import { HttpClient, createHttpGetOptions } from '../../../../services/http/http-client';
import { SET_MAIN_NAV_ACTIVE, UPDATE_SYSTEM_LANGUAGE } from '../../../../store/app/types';
import { REQUEST_CANCELLED } from '../../../../services/http/error-handler';
import { HttpLib } from '../../../../services/http/http-lib';
import router from '../../../../router';
import { setMainNavInactive } from '../../../../store/app/mutations';
import { NotificationService } from '../../../../dt-plugins/notification/notification.service';
import { getNavTabModule } from '../../../../dt-plugins/sidewindow/nav-tab';
let userDetailsSource;

const NavTabModule = getNavTabModule(types.ExternalUserDetails, 'externalUserDetails');
const external_user_idr = () => router.currentRoute.params.external_user_id;

export const externalUserActions = {
  ...NavTabModule.implementActions(
    'external_user_id',
    'externalusers/external_user_id/tab',
    'externalusers',
    () => router,
    'settings',
    (value, key) => {
      return {
        title: value?.ext_user?.user_name ?? key,
        full_title: value?.ext_user?.user_name ?? key,
      }
    }
  ),
  // Show Sidewindow
  async [types.ExternalUserDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    let { flag, externaluser, reload } = payload;

    flag = typeof flag === "boolean" ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = "external_user_id";
    const itemName = "externaluser";
    const item = payload[itemName];

    if (!item) {
    return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = "externalUserDetails";
    const DetailsAction = types.ExternalUserDetails;

    // Check Reload and prexisting Item Logic
    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }
    
    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
          [itemName]: item,
          loading: true
      };
    });

    // HTTP Req
    const userDetails = await UserService.findExternalUserDetails({
      external_user_id: primaryKeyValue
    });
    const permissions = await UserService.loadRoyaltyStatementPermissions({
      external_user_id: primaryKeyValue
    });

    const detailsData = {
      ...userDetails.data,
      ...permissions.data
    };

    // console.log('externalUserDetails:mdsir', detailsData);

    NavTabHelper.setSingleNavTabDetails(
    primaryKeyValue,
    (detailsDict, externalUser) => {
        return {
        ...externalUser,
        ...detailsData,
        loading: false,
        };
    });
  },
  async [types.ExternalUserDetails.UPDATE.MULTIPLE]({ dispatch, getters }, payload) {
    const { external_user_id, ...rest } = payload;
    const userID = external_user_id ?? external_user_idr();

    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(userID, userDetailsObj => {
      return {
        ...userDetailsObj,
        ...rest
      };
    });
  },

  async [types.ExternalUsers.FETCH.ALL]({ commit }, payload) {
    const { username, password } = payload;
    const userlistData = await UserService.findUserList({
      user_name: username,
      password: password
    }).then(res => res.data);
    if (userlistData.ext_users && userlistData.ext_users.length > 0) {
      commit(types.ExternalUsers.SET.ALL, userlistData);
      return Promise.resolve(userlistData);
    } else {
      return Promise.reject(userlistData.status);
    }
  },
  async [types.ExternalUsers.UPDATE.SINGLE]({ commit, getters, rootGetters }, payload) {
    const { name, value, item } = payload;

    const key = 'external_user_id';
    const kVal = item[key];
    const table = 'external_users';

    commit(types.ExternalUsers.SET.ALL, {
      ...getters.externalUserList,
      ext_users: getters.externalUserList.ext_users.map(e => {
        if (e[key] == kVal) {
          return {
            ...e,
            [name]: value
          };
        } else {
          return e;
        }
      })
    });

    const updateUser = await HttpClient.modify(
      key,
      kVal,
      name,
      value,
      table
    );

  },

  async [types.SelectedExternalUser.SET.SINGLE]({ commit }, payload) {
    const { externaluser, flag } = payload;

    setMainNavInactive(commit, flag);

    if (flag) {
      const { external_user_id } = externaluser;

      userDetailsSource && userDetailsSource.cancel(REQUEST_CANCELLED);
      userDetailsSource = HttpLib.CancelToken.source();

      const userDetails = await UserService.findExternalUserDetails({
        external_user_id
      }, createHttpGetOptions({
        cancelToken: userDetailsSource.token
      }));
      const permissions = await UserService.loadRoyaltyStatementPermissions({
        external_user_id
      }, createHttpGetOptions({
        cancelToken: userDetailsSource.token
      }));

      commit(types.SelectedExternalUser.SET.SINGLE, {
        ...userDetails.data,
        ...permissions.data
      });
    }

  },
  async [types.RoyaltyAccounts.SET.ALL]({ commit, state, dispatch }, payload) {
    // commit(types.RoyaltyAccounts.SET.ALL, payload);
    dispatch(types.ExternalUserDetails.UPDATE.MULTIPLE, { royalty_accounts: payload});
  },
  async [types.AllExternalUsers.FETCH.ALL]({ commit, state, dispatch }) {
    const res = await UserService.getAllExternalUsers();
    commit(types.AllExternalUsers.SET.ALL, res.data.ext_users);
  },
  async [types.SearchExternalUsers.FETCH.ALL]({ commit, state, dispatch }, payload) {
    const res = await UserService.searchExternalUsers(payload);
    console.log('res.data.ext_users',res)
    commit(types.AllExternalUsers.SET.ALL, res.data.ext_users);
  },
  async [types.SELECT_EXTERNAL_USER_AUTO]({ commit, getters }, payload) {
    console.log('aaaa')
    router.push({
      name: 'externalusers'
    });
  },
  async [types.ExternalUsers.INSERT.SINGLE]({ commit, getters }, payload) {

    const newUsers = await UserService.insertExternalUser({
      ...payload
    });
if(newUsers.data.ext_user){
  commit(types.ExternalUsers.SET.ALL, {
    ...getters.externalUserList,
    ext_users: [
      ...getters.externalUserList.ext_users,
      newUsers.data.ext_user
    ],
  });
}
else{
  NotificationService.showNotification({
    text: 'This Username already exists',
    timeout: 5000,
    type: 'error'
  });
}
  
  },

  async [types.ExternalUsers.DELETE.SINGLE]({ commit, getters }, payload) {
    const external_user_id = payload;

    commit(types.ExternalUsers.SET.ALL, {
      ...getters.externalUserList,
      ext_users: getters.externalUserList.ext_users.filter(user => user.external_user_id != external_user_id),
    });

    const deletedUser = await UserService.removeExternalUsers({
      external_user_id: external_user_id,
    });
  },
  async [types.RoyaltyAccounts.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const external_users_permission_id = payload;

    // commit(types.RoyaltyAccounts.SET.ALL,
    //   getters.externalUserDetails.royalty_accounts.filter(user => user.external_users_permission_id != external_users_permission_id),
    // );

    const selectedUser = getters.externalUserDetails[external_user_idr()];
    const royalty_accounts = selectedUser.royalty_accounts.filter(user => user.external_users_permission_id != external_users_permission_id);
    dispatch(types.ExternalUserDetails.UPDATE.MULTIPLE, { royalty_accounts });

    const deletedUser = await UserService.removeExternalUserPermission({
      external_users_permission_id: external_users_permission_id,
    });
  }
};